// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1sFUL","footer":"ModalFilter_footer__1yg0B"};